module.exports = __webpack_public_path__ + "media/images/icn-linkedin-footer-bcfbf889.png";